export default ({ store }) => {
  if (!store.getters['countries/countryGroupsLoaded']) {
    return store.dispatch('countries/loadCountryGroupsAndCountryNames')
  }
}
